export type ServiceInfoKey =
	| 'CookiesVideoPermission'
	| 'FetchingData'
	| 'FullyBooked'
	| 'ExpectedWaitingTime'
	| 'HistoricNotApplicable'
	| 'ListenToThisPageWithWebReader'
	| 'NoJobs'
	| 'NoNews'
	| 'NoPublications'
	| 'NoWebinars'
	| 'SkipToMain'
	| 'WeAreOpenUntil'
	| 'WeOpen$Clock$Time'
	| 'WeOpen$Day$Clock$Time'
	| '$Clock$Time';

interface DictionaryFunctions {
	get(key: ServiceInfoKey): string;
}

export const ServiceInfoItems = (getValue: (key: string, defaultValue?: string) => string): DictionaryFunctions => {
	return {
		get: (key: ServiceInfoKey): string => {
			switch (key) {
				case 'CookiesVideoPermission':
					return getValue('ServiceInfo.CookiesVideoPermission', 'For at afspille videoen beder vi om din tilladelse til at bruge cookies.');
				case 'FetchingData':
					return getValue('ServiceInfo.FetchingData', 'Henter data...');
				case 'FullyBooked':
					return getValue('ServiceInfo.FullyBooked', 'Fuldt booket');
				case 'ExpectedWaitingTime':
					return getValue('ServiceInfo.ExpectedWaitingTime', 'Forventet ventetid');
				case 'HistoricNotApplicable':
					return getValue('ServiceInfo.HistoricNotApplicable', 'Historisk - ikke gældende');
				case 'ListenToThisPageWithWebReader':
					return getValue('ServiceInfo.ListenToThisPageWithWebReader', 'Lyt til denne side med ReadSpeaker webReader');
				case 'NoJobs':
					return getValue('ServiceInfo.NoJobs', 'Der er ingen ledige stillinger i øjeblikket.');
				case 'NoNews':
					return getValue('ServiceInfo.NoNews', 'Der er ingen nyheder i øjeblikket.');
				case 'NoPublications':
					return getValue('ServiceInfo.NoPublications', 'Der er ingen publikationer i øjeblikket.');
				case 'NoWebinars':
					return getValue('ServiceInfo.NoWebinars', 'Der er ingen webinarer i øjeblikket.');
				case 'SkipToMain':
					return getValue('ServiceInfo.SkipToMain', 'Klik for at skippe navigation og gå direkte til indhold');
				case 'WeAreOpenUntil':
					return getValue('ServiceInfo.WeAreOpenUntil', 'Vi er åbne til');
				case 'WeOpen$Clock$Time':
					return getValue('ServiceInfo.WeOpen$Clock$Time', 'Vi åbner {value1} {value2}');
				case 'WeOpen$Day$Clock$Time':
					return getValue('ServiceInfo.WeOpen$Day$Clock$Time', 'Vi åbner {value1} {value2} {value3}');
				case '$Clock$Time':
					return getValue('ServiceInfo.$Clock$Time', ' {value1} {value2}');
			}
		},
	};
};
